<app-page-shell variant="default">
<div class="card card-box mb-5">
      <div class="card-header py-3">
        <div class="card-header--title font-size-lg">
          Manage Registration Platforms
        </div>
      </div>
      <div class="row m-0">
      </div>
      <div class="sticky-dropdown-custom-table register-platform-table pagination-table p-3 registration-platform-cards-host">
        <div class="registration-platform-toolbar">
          <label class="registration-platform-search-label" for="registration-platform-search">
            <span class="sr-only">Search platforms</span>
            <input id="registration-platform-search"
                   type="search"
                   class="registration-platform-search-input"
                   [(ngModel)]="platformSearchQuery"
                   (ngModelChange)="onRegistrationPlatformSearchChange()"
                   placeholder="Search platforms..."
                   autocomplete="off"/>
          </label>
        </div>

        <div *ngIf="registrationPlatformList.length > 0"
             class="registration-platform-grid"
             role="list">
          <article *ngFor="let platform of registrationPlatformList; let i = index"
                   class="registration-platform-card"
                   role="listitem">
            <header class="registration-platform-card-header">
              <div class="platform-card-header">
                <div class="platform-card-info">
                  <div class="platform-card-avatar"
                       [ngClass]="platform.image ? 'platform-card-avatar--image' : ('platform-initials--' + platform.slug)">
                    <img *ngIf="platform.image" class="platform-card-avatar-img" [src]="platform.image" alt=""/>
                    <span *ngIf="!platform.image" class="platform-card-initials-text"
                          [class.platform-card-initials-text--single]="getPlatformCardInitials(platform.name).length === 1"
                          aria-hidden="true">{{ getPlatformCardInitials(platform.name) }}</span>
                  </div>
                  <div class="pagination-name platform-card-title">
                    {{platform.name}}
                    <ng-container *ngIf="getLastSyncTime(platform.slug)">
                      <app-info-popover container="body" info="{{getLastSyncTime(platform.slug)}}"></app-info-popover>
                    </ng-container>
                  </div>
                </div>
                <div class="platform-card-header-toggle">
                  <div class="widget_code pagination-status-checkbox platform-card-toggle">
                    <span class="platform-card-toggle-inner">
                      <a *ngIf="!onChecked(i , platform.slug)"
                         href="#"
                         (click)="$event.preventDefault(); onActiveChange(true, authCadmiumModel, authCventModel, authSwoogoModel,authSwoogoSponsorModel, authMockModel, authSwapcardModel, authLineUpNinjaModel, authTerrapinSalesforceModel, authSessionBoardModel, authMapYourShowModel, authPersonifyA2ZModel, authTechEventModel, platform, i)"
                         title="Activate"
                         class="activate platform-card-toggle-link platform-card-pill-switch platform-card-pill-switch--off"
                         role="button"><span class="sr-only">Activate</span><i class="fa fa-toggle-off platform-card-pill-switch-fa-fallback" aria-hidden="true"></i></a>
                      <a *ngIf="onChecked(i , platform.slug)"
                         href="#"
                         (click)="$event.preventDefault(); onActiveChange(false, authCadmiumModel, authCventModel, authSwoogoModel,authSwoogoSponsorModel, authMockModel, authSwapcardModel, authLineUpNinjaModel, authTerrapinSalesforceModel, authSessionBoardModel, authMapYourShowModel, authPersonifyA2ZModel, authTechEventModel, platform, i)"
                         title="Deactivate"
                         class="deactivate platform-card-toggle-link platform-card-pill-switch platform-card-pill-switch--on"
                         role="button"><span class="sr-only">Deactivate</span><i class="fa fa-toggle-on platform-card-pill-switch-fa-fallback" aria-hidden="true"></i></a>
                    </span>
                  </div>
                </div>
              </div>
            </header>
            <footer class="registration-platform-card-footer">
              <div class="platform-card-actions">
                <button type="button" class="btn platform-card-icon-btn" (click)="showPreviousSyncLogs(platform.id)" title="Sync logs">
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  [disabled]="!isPlatformActive(platform) || (isPlatformActive(platform) && (loader$ | async) || (loaderImport$ | async))"
                  class="btn platform-card-sync-btn" (click)="submitInfluencerSync(platform, i)">
                  <span *ngIf="((loader$ | async) || (loaderImport$ | async)) && this.currentSyncId === platform.id" class="btn-wrapper--icon spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                  Sync
                  <span *ngIf="((loader$ | async) || (loaderImport$ | async)) && this.currentSyncId === platform.id">

                    <span class="btn-wrapper--label">
                    {{importProgress.status === 'started' ?
                      ': started' :
                      importProgress.status === 'in-progress' ?
                        ': in-progress' :
                        importProgress.status === 'uploading' ?
                          ': uploading' :
                          ': ' + importProgress.status}}
                    </span> {{ importProgress.progress}} %

                  </span>
                </button>
              </div>
            </footer>
          </article>
        </div>

        <p *ngIf="registrationPlatformsLoaded && registrationPlatformList.length === 0"
           class="registration-platform-empty text-muted mb-0 py-4 text-center">
          {{ registrationPlatformsEmptyMessage }}
        </p>
      </div>
</div>
</app-page-shell>

<ng-template #authSwapcardModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authSwapcardForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">
        <div class="row mx-auto">
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Auth Key <span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('auth_key')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="auth_key"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new Auth Key"/>
              <div *ngIf="submitted && s.auth_key.errors" class="mt-1">
                <div *ngIf="s.auth_key.errors.required" class="invalid-text">Auth Key is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Event Id <span class="text-danger">*</span></label>
              <input formControlName="event_id"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off" placeholder="Enter Event Id"/>
              <div *ngIf="submitted && s.event_id.errors" class="mt-1">
                <div *ngIf="s.event_id.errors.required" class="invalid-text">Event Id is required</div>
              </div>
            </div>
          </div>

          <div *ngFor="let influencerKeys of influencerKeysFormGroup.controls; let i = index" formArrayName="influencer_keys" class="col-12 p-0">
            <div [formGroupName]="i">
              <div class="container-fluid">
                <div class="row align-items-start mt-3">
                  <div class="col-md-4 col-sm-12">
                    <div class="api-platform-field">
                      <label class="api-platform-field-label">Influencer Key <span class="text-danger">*</span></label>
                      <input class="api-platform-input form-control" formControlName="name"
                             type="text" autocomplete="off" placeholder="Enter Influencer Key">
                    </div>
                  </div>

                  <div class="col-md-4 col-sm-12">
                    <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal"
                                          [hideInfo]="true"
                                          [isCreatable]="false"
                                          [placeholder]="'Select the category'"
                                          [labelText]="'Category'"
                                          [selectOptions]="influencerTypes"
                                          [selectedValue]="influencerKeysFormGroup.at(i).value.category"
                                          (optionSelected)="onSwapcardKeyCategorySelect($event, i)"></app-creatable-select>
                  </div>

                  <div class="col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                      <div class="flex-1">
                        <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal"
                                              [hideInfo]="true"
                                              [isCreatable]="false"
                                              [placeholder]="swapcardSegmentPlaceholder(influencerKeysFormGroup.at(i).value.category)"
                                              [labelText]="swapcardSegmentFieldLabel(influencerKeysFormGroup.at(i).value.category)"
                                              [selectOptions]="swapcardSegmentOptionsForCategory(influencerKeysFormGroup.at(i).value.category)"
                                              [isDisabled]="!influencerKeysFormGroup.at(i).value.category || influencerKeysFormGroup.at(i).value.category === 'null'"
                                              [selectedValue]="influencerKeysFormGroup.at(i).value.segmentId"
                                              (optionSelected)="onSwapcardKeySegmentSelect($event, i)"></app-creatable-select>
                        </div>
                          <div class="d-flex align-items-center justify-content-end px-2">
                            <a class="pointer ml-2" (click)="removeInfluencerKeysButtonClick(i)"
                              *ngIf="!(influencerKeysFormGroup.controls.length === 1 || influencerKeysFormGroup.controls.length === i)">
                              <i class="fa fa-times-circle remove-btn"></i>
                            </a>
                            <a class="pointer ml-2" (click)="addInfluencerKeysButtonClick()"
                              *ngIf="influencerKeysFormGroup.controls.length-1 === i">
                              <i class="fa fa-plus-circle add-btn"></i>
                            </a>
                        </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <!--          <div class="col-lg-4 col-md-12 col-ms-12">-->
          <!--            <div class="floating-label">-->
          <!--              <input formControlName="attendee_key" placeholder=" "-->
          <!--                     class="floating-input"-->
          <!--                     type="text" autocomplete="off"/>-->
          <!--              <label>Attendee Key-->
          <!--              </label>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="col-lg-4 col-md-12 col-ms-12">-->
          <!--            <div class="floating-label">-->
          <!--              <input formControlName="speaker_key" placeholder=" "-->
          <!--                     class="floating-input"-->
          <!--                     type="text" autocomplete="off"/>-->
          <!--              <label>Speaker Key-->
          <!--              </label>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="col-lg-4 col-md-12 col-ms-12">-->
          <!--            <div class="floating-label">-->
          <!--              <input formControlName="partner_key" placeholder=" "-->
          <!--                     class="floating-input"-->
          <!--                     type="text" autocomplete="off"/>-->
          <!--              <label>Partner Key-->
          <!--              </label>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="col-lg-12 col-md-12 col-ms-12 mt-4">
            <label>How to handle records without email?</label>
            <div class="ml-2">
              <label class="custom-checkbox">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Skip
              </label>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-ms-12 mt-3" *ngIf="currentPlatform?.supports_push_links">
            <label>Enable Push Share Links</label>
            <div class="ml-2">
              <label class="custom-checkbox">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable
              </label>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-ms-12 mt-3">
            <label>How to handle deletion</label>
            <div class="d-flex align-items-center url-type">
              <label class="custom-radio">
                <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
              </label>
              <ng-container>
                <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is." ></app-info-popover>
              </ng-container>

              <label class="custom-radio">
                <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
              </label>
              <ng-container>
                <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead." ></app-info-popover>
              </ng-container>

              <label class="custom-radio">
                <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Delete on Snöball Forced
              </label>
              <ng-container>
                <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals." ></app-info-popover>
              </ng-container>

              <label class="custom-radio">
                <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball" checked="checked"><span class="radiomark"></span>Skip on Snöball
              </label>
              <ng-container>
                <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails." ></app-info-popover>
              </ng-container>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-ms-12">
            <div *ngIf="!isSwapcardFormValid" class="invalid-text">Each influencer key needs a name, category, and segment</div>
          </div>

        </div>
        <div _ngcontent-c4="" class="text-right mt-3">
          <button _ngcontent-c4="" class="btn btn-default mr-2" type="button" (click)="onCancel()">Cancel</button>
          <button _ngcontent-c4="" class="btn btn-primary mr-2" type="submit">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #authLineUpNinjaModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authLineUpNinjaForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">
        <div class="row mx-auto">
          <div class="col-lg-11 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Webhook</label>
              <input [readonly]="true" formControlName="webhook" required="required"
                     class="api-platform-input form-control webhook-input"
                     type="text" autocomplete="off" placeholder=""/>
            </div>
          </div>
          <div class="copy-container">
            <span class="copy-clipboard cursor-pointer">
              <i title="copy" (click)="copyWebHook(authLineUpNinjaForm.value.webhook)" class="fa fa-clone"></i>
            </span>
          </div>

          <div class="col-lg-12 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">API URL</label>
              <input formControlName="api_url" required="required"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off" placeholder="Enter API URL"/>
              <div *ngIf="submitted && l.api_url.errors" class="mt-1">
                <div *ngIf="l.api_url.errors !== null && !l.api_url.errors.required" class="invalid-text">Please enter
                  valid API format
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Username</label>
              <small *ngIf="isCredentialFieldConfigured('username')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="username"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new Username"/>
              <div class="mt-1">
                <div *ngIf="!isLienUpNinjaFormValid" class="invalid-text">Please fill all values</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Password</label>
              <small *ngIf="isCredentialFieldConfigured('password')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="password"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new password"/>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #speakerSegment placeholder="Select segment" [selectOptions]="speakerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'" [labelText]="'Select Speaker Segment'"
                                  (optionSelected)="onSegmentSelect($event, 'speaker')"
                                  [selectedValue]="selectedSpeakerSegment"></app-creatable-select>
          </div>
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Skip records if…</p>
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Missing email
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable share links
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">On deletion</p>
            <div class="api-platform-option-list">
              <div class="d-flex align-items-center url-type flex-wrap">
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #authTerrapinSalesforceModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authTerrapinSalesforceForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">

          <div class="row mx-auto">
            <div class="col-md-12 col-ms-12">
              <div class="col-lg-6 p-0">
                <div class="api-platform-field">
                  <label class="api-platform-field-label">Project Edition ID (Ex.: ASDF43534,FDS_a3444,fDSadd...)</label>
                  <input formControlName="project_edition_id"
                         class="api-platform-input form-control"
                         type="text" autocomplete="off" placeholder="Enter Project Edition ID"/>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-ms-12 mt-2">
              <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"
                                    [hideInfo]="true" [placeholder]="'Select segment'"
                                    [labelText]="'Select Sponsor Segment'"
                                    (optionSelected)="onSalesForceSegmentSelect($event, 'sponsors')"
                                    [selectedValue]="selectedSalesForceSponsorSegment"></app-creatable-select>
            </div>
            <div class="col-lg-4 col-md-12 col-ms-12 mt-2">
              <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"
                                    [hideInfo]="true" [placeholder]="'Select segment'"
                                    [labelText]="'Select Exhibitor Segment'"
                                    (optionSelected)="onSalesForceSegmentSelect($event, 'exhibitor')"
                                    [selectedValue]="selectedSalesForceExhibitorSegment"></app-creatable-select>
            </div>
            <div class="col-lg-4 col-md-12 col-ms-12 mt-2">
              <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #speakerSegment placeholder="Select segment" [selectOptions]="speakerSegments"
                                    [hideInfo]="true" [placeholder]="'Select segment'"
                                    [labelText]="'Select Speaker Segment'"
                                    (optionSelected)="onSalesForceSegmentSelect($event, 'speaker')"
                                    [selectedValue]="selectedSalesForceSpeakerSegment"></app-creatable-select>
            </div>


            <div class="col-lg-4 col-md-12 col-ms-12 mt-2">
              <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #attendeeSegment placeholder="Select segment" [selectOptions]="attendeeSegments"
                                    [hideInfo]="true" [placeholder]="'Select segment'"
                                    [labelText]="'Select Guest Segment'"
                                    (optionSelected)="onSalesForceSegmentSelect($event, 'guest')"
                                    [selectedValue]="selectedSalesForceGuestSegment"></app-creatable-select>
            </div>

            <div class="col-lg-4 col-md-12 col-ms-12 mt-2">
              <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #attendeeSegment placeholder="Select segment" [selectOptions]="attendeeSegments"
                                    [hideInfo]="true" [placeholder]="'Select segment'"
                                    [labelText]="'Select Other Attendee Segment'"
                                    (optionSelected)="onSalesForceSegmentSelect($event, 'otherAttendees')"
                                    [selectedValue]="selectedSalesForceOtherAttendeeSegment"></app-creatable-select>
            </div>
            <div class="col-12 api-platform-section">
              <p class="api-platform-section-title">Skip records if…</p>
              <div class="api-platform-option-list">
                <label class="custom-checkbox d-block mb-0">
                  <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                  <span class="checkmark"></span>
                  Missing email
                </label>
              </div>
            </div>
            <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
              <div class="api-platform-option-list">
                <label class="custom-checkbox d-block mb-0">
                  <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                  <span class="checkmark"></span>
                  Enable share links
                </label>
              </div>
            </div>
            <div class="col-12 api-platform-section">
              <p class="api-platform-section-title">On deletion</p>
              <div class="api-platform-option-list">
                <div class="d-flex align-items-center url-type flex-wrap">
                  <label class="custom-radio">
                    <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                  </label>
                  <ng-container>
                    <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                  </ng-container>
                  <label class="custom-radio">
                    <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                  </label>
                  <ng-container>
                    <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                  </ng-container>
                  <label class="custom-radio">
                    <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                  </label>
                  <ng-container>
                    <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                  </ng-container>
                  <label class="custom-radio">
                    <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                  </label>
                  <ng-container>
                    <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-ms-12 mt-3 bar error-brd">
              <div *ngIf="!isTerrapinSalesforceFormValid" class="invalid-text">Please fill all values</div>
            </div>
          </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #authCventModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authCventForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">

        <div class="row mx-auto">
<!--          <div class="col-lg-12 col-md-12 col-ms-12">-->
<!--            <div class="floating-label">-->
<!--              <input formControlName="api_url" placeholder=" "-->
<!--                     required="required" class="floating-input"-->
<!--                     type="text" autocomplete="off"/>-->
<!--              <label>API URL <span class="red">*</span>-->
<!--              </label>-->
<!--              <div *ngIf="submitted && c.api_url.errors" class="bar error-brd">-->
<!--                <div *ngIf="c.api_url.errors !== null && !c.api_url.errors.required" class="invalid-text">Please enter-->
<!--                  valid API URL format-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

          <div class="col-lg-6 col-md-6 col-ms-6">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Client Secret <span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('client_secret')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="client_secret"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new Client Secret"/>
              <div *ngIf="submitted && cv.client_secret.errors" class="mt-1">
                <div *ngIf="cv.client_secret.errors !== null && cv.client_secret.errors.required" class="invalid-text">Client Secret is required</div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-ms-6">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Client ID <span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('client_id')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="client_id"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new Client ID"/>
              <div class="mt-1">
                <div *ngIf="!isCventFormValid" class="invalid-text">Please fill all values</div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-ms-6">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Event ID <span class="text-danger">*</span></label>
              <input formControlName="event_id"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off" placeholder="Enter Event ID"/>
              <div class="mt-1">
                <div *ngIf="!isCventFormValid" class="invalid-text">Please fill all values</div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-ms-6">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Custom Snöball field</label>
              <input formControlName="custom_snoball_field" placeholder="snoball_url: custom push link"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off"/>
            </div>
          </div>

          <!--          <div class="col-lg-4 col-md-12 col-ms-12 mt-3">-->
          <!--             <app-creatable-select #attendeeSegment placeholder="Select segment" [selectOptions]="attendeeSegments"-->
          <!--                                   [hideInfo]="true" [placeholder]="'Select Attendee Segment'"-->
          <!--                                   [labelText]="'Select Attendee Segment'"-->
          <!--                                   (optionSelected)="onSegmentSelect($event, 'attendee')"-->
          <!--                                   [selectedValue]="selectedAttendeeSegment"></app-creatable-select>-->
          <!--          </div>-->
          <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #speakerSegment placeholder="Select segment" [selectOptions]="speakerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Select Speaker Segment'"
                                  (optionSelected)="onSegmentSelect($event, 'speaker')"
                                  [selectedValue]="selectedSpeakerSegment"></app-creatable-select>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Select Partner Segment'"
                                  (optionSelected)="onSegmentSelect($event, 'partner')"
                                  [selectedValue]="selectedPartnerSegment"></app-creatable-select>
          </div>
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Skip records if…</p>
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Missing email
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable share links
              </label>
              <label class="custom-checkbox d-block mb-0 mt-2">
                <input class="mr-1" formControlName="enable_admin_sync" type="checkbox" value="true">
                <span class="checkmark"></span>
                Include exhibitor admin
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">On deletion</p>
            <div class="api-platform-option-list">
              <div class="d-flex align-items-center url-type flex-wrap">
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #authSwoogoModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authSwoogoForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">
        <div class="row mx-auto">
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">API Key<span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('api_key')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="api_key"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new API Key"/>
              <div *ngIf="submitted && swo.api_key.errors" class="mt-1">
                <div *ngIf="swo.api_key.errors !== null && swo.api_key.errors.required" class="invalid-text">API KEY is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">API Secret<span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('api_secret')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="api_secret"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new API Secret"/>
              <div *ngIf="submitted && swo.api_secret.errors" class="mt-1">
                <div *ngIf="swo.api_secret.errors !== null && swo.api_secret.errors.required" class="invalid-text">API KEY is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Event ID <span class="text-danger">*</span></label>
              <input formControlName="event_id"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off" placeholder="Enter Event ID"/>
              <div *ngIf="submitted && swo.event_id.errors" class="mt-1">
                <div *ngIf="swo.event_id.errors !== null && swo.event_id.errors.required" class="invalid-text">Event ID is required</div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #speakerSegment placeholder="Select segment" [selectOptions]="speakerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Select Speaker Segment'"
                                  (optionSelected)="onSegmentSelect($event, 'speaker')"
                                  [selectedValue]="selectedSpeakerSegment">
            </app-creatable-select>
          </div>

          <!-- Field Mapping Section -->
          <div class="col-lg-12 col-md-12 col-ms-12 mt-4">
            <h4 class="modal-title">Map Fields</h4>
            <div class="field-mapping-table mt-2">
              <div class="row align-items-center mt-3" >
                <div class="label col-lg-6 col-md-12 col-ms-12">
                  <h6>Swoogo</h6>
                </div>
                <div class="label col-lg-6 col-md-12 col-ms-12">
                  <h6>Snöball</h6>
                </div>
              </div>
              <!-- Mapped Field Rows -->
              <div class="row align-items-center mt-1" *ngFor="let field of visibleFields; let i = index">
                <div class="col-md-5 col-sm-12">
                  <div class="d-flex align-items-center">
                    <div class="api-platform-field w-100">
                      <label class="api-platform-field-label">Swoogo field</label>
                      <input type="text" class="api-platform-input form-control"
                             [(ngModel)]="field.value"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="e.g. email, first_name" />
                    </div>
                    <a *ngIf="visibleFields.length > 1"
                       class="pointer mt-1 ml-2"
                       (click)="removeVisibleField(i, field)">
                      <i class="fa fa-times-circle remove-btn"></i>
                    </a>
                    <a *ngIf="i === visibleFields.length - 1"
                       class="pointer ml-2"
                       (click)="addEmptyField()">
                      <i class="fa fa-plus-circle add-btn"></i>
                    </a>
                  </div>
                </div>
                <div class="col-md-1 col-sm-12">
                  <a class="ml-2" >
                    <i class="fa fa-long-arrow-right arrow-icon"></i>
                  </a>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="d-flex align-items-center">
                    <div class="api-platform-field w-100">
                      <label class="api-platform-field-label">Snöball field</label>
                      <div class="api-platform-native-select">
                        <select class="api-platform-input form-control chevronSelectOption"
                                [(ngModel)]="field.key"
                                [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="onFieldKeyChange(i)">
                          <option [ngValue]="null" disabled>Select a field</option>
                          <option *ngFor="let f of allFields" [ngValue]="f.key" [disabled]="isFieldDisabled(f.key)">
                            {{ f.label }}
                          </option>
                        </select>
                        <i class="fa fa-angle-down api-platform-native-select-icon" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Skip records if…</p>
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Missing email
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable share links
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">On deletion</p>
            <div class="api-platform-option-list">
              <div class="d-flex align-items-center url-type flex-wrap">
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #authSwoogoSponsorModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authSwoogoSponsorsForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">
        <div class="row mx-auto">
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">API Key <span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('api_key')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="api_key"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new API Key"/>
              <div *ngIf="submitted && swos.api_key.errors" class="mt-1">
                <div *ngIf="swos.api_key.errors !== null && swos.api_key.errors.required" class="invalid-text">API KEY is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">API Secret<span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('api_secret')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="api_secret"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new API Secret"/>
              <div *ngIf="submitted && swos.api_secret.errors" class="mt-1">
                <div *ngIf="swos.api_secret.errors !== null && swos.api_secret.errors.required" class="invalid-text">API KEY is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Event ID <span class="text-danger">*</span></label>
              <input formControlName="event_id"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off" placeholder="Enter Event ID"/>
              <div *ngIf="submitted && swos.event_id.errors" class="mt-1">
                <div *ngIf="swos.event_id.errors !== null && swos.event_id.errors.required" class="invalid-text">Event ID is required</div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"
                                [hideInfo]="true" [placeholder]="'Select segment'"
                                [labelText]="'Select Partner Segment'"
                                (optionSelected)="onSegmentSelect($event, 'partner')"
                                [selectedValue]="selectedPartnerSegment">
            </app-creatable-select>
          </div>

          <!-- Field Mapping Section -->
          <div class="col-lg-12 col-md-12 col-ms-12 mt-4">
            <h4 class="modal-title">Map Fields</h4>
            <div class="field-mapping-table mt-2">
              <div class="row align-items-center mt-3" >
                <div class="label col-lg-6 col-md-12 col-ms-12">
                  <h6>Swoogo</h6>
                </div>
                <div class="label col-lg-6 col-md-12 col-ms-12">
                  <h6>Snöball</h6>
                </div>
              </div>
              <!-- Mapped Field Rows -->
              <div class="row align-items-center mt-1" *ngFor="let field of visibleFields; let i = index">
                <div class="col-md-5 col-sm-12">
                  <div class="d-flex align-items-center">
                    <div class="api-platform-field w-100">
                      <label class="api-platform-field-label">Swoogo field</label>
                      <input type="text" class="api-platform-input form-control"
                             [(ngModel)]="field.value"
                             [ngModelOptions]="{ standalone: true }"
                             placeholder="e.g. email, first_name" />
                    </div>
                    <a *ngIf="visibleFields.length > 1"
                       class="pointer mt-1 ml-2"
                       (click)="removeVisibleField(i, field)">
                      <i class="fa fa-times-circle remove-btn"></i>
                    </a>
                    <a *ngIf="i === visibleFields.length - 1"
                       class="pointer ml-2"
                       (click)="addEmptyField()">
                      <i class="fa fa-plus-circle add-btn"></i>
                    </a>
                  </div>
                </div>
                <div class="col-md-1 col-sm-12">
                    <a class="ml-2" >
                      <i class="fa fa-long-arrow-right arrow-icon"></i>
                    </a>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="d-flex align-items-center">
                    <div class="api-platform-field w-100">
                      <label class="api-platform-field-label">Snöball field</label>
                      <div class="api-platform-native-select">
                        <select class="api-platform-input form-control chevronSelectOption"
                                [(ngModel)]="field.key"
                                [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="onFieldKeyChange(i)">
                          <option [ngValue]="null" disabled>Select a field</option>
                          <option *ngFor="let f of allFields" [ngValue]="f.key" [disabled]="isFieldDisabled(f.key)">
                            {{ f.label }}
                          </option>
                        </select>
                        <i class="fa fa-angle-down api-platform-native-select-icon" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Skip records if…</p>
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Missing email
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable share links
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">On deletion</p>
            <div class="api-platform-option-list">
              <div class="d-flex align-items-center url-type flex-wrap">
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>


<ng-template #authTechEventModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authTechEventForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">
        <div class="row mx-auto">
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">API Key<span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('api_key')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="api_key"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password"
                     placeholder="Enter a new Booth Staff API Key"/>
              <div *ngIf="submitted && te.api_key.errors" class="mt-1">
                <div *ngIf="te.api_key.errors !== null && te.api_key.errors.required" class="invalid-text">API Key is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Select Booth Staff Segment'"
                                  (optionSelected)="onSegmentSelect($event, 'partner')"
                                  [selectedValue]="selectedPartnerSegment">
            </app-creatable-select>
          </div>

          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Skip records if…</p>
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Missing email
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable share links
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">On deletion</p>
            <div class="api-platform-option-list">
              <div class="d-flex align-items-center url-type flex-wrap">
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #authMockModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">Mock Platform (Testing)</h4>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="alert alert-info">
      <i class="fa fa-info-circle mr-2"></i>
      This is a mock platform for testing.
    </div>
    <div class="form-wraper">
      <form [formGroup]="authMockForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">
        <div class="row mx-auto">
          <div class="col-lg-12 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Number of records to fetch <span class="text-danger">*</span></label>
              <input formControlName="number_of_records"
                     class="api-platform-input form-control"
                     type="number" min="1" max="1000" autocomplete="off" placeholder=""/>
              <div *ngIf="submitted && mock.number_of_records.errors" class="mt-1">
                <div *ngIf="mock.number_of_records.errors !== null && mock.number_of_records.errors.required" class="invalid-text">Number of records is required</div>
              </div>
              <small class="text-muted d-block mt-1">Fetch between 1-1000 user records from fake.jsonmockapi.com</small>
            </div>
          </div>

          <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #attendeeSegment placeholder="Select segment" [selectOptions]="attendeeSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Select Attendee Segment (Optional)'"
                                  (optionSelected)="onSegmentSelect($event, 'attendee')"
                                  [selectedValue]="selectedAttendeeSegment">
            </app-creatable-select>
          </div>

          <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #speakerSegment placeholder="Select segment" [selectOptions]="speakerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Select Speaker Segment (Optional)'"
                                  (optionSelected)="onSegmentSelect($event, 'speaker')"
                                  [selectedValue]="selectedSpeakerSegment">
            </app-creatable-select>
          </div>

          <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"
                                [hideInfo]="true" [placeholder]="'Select segment'"
                                [labelText]="'Select Partner Segment (Optional)'"
                                (optionSelected)="onSegmentSelect($event, 'partner')"
                                [selectedValue]="selectedPartnerSegment">
            </app-creatable-select>
          </div>

          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Skip records if…</p>
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Missing email
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable share links
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">On deletion</p>
            <div class="api-platform-option-list">
              <div class="d-flex align-items-center url-type flex-wrap">
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Marks influencer as skipped (Don't include them in the campaign)."></app-info-popover>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Testing options</p>
            <div class="api-platform-option-list d-flex flex-wrap align-items-center">
              <label class="custom-checkbox mb-0 mr-2">
                <input class="mr-1" formControlName="simulate_failure" type="checkbox" value="true">
                <span class="checkmark"></span>
                Simulate sync failure
              </label>
              <app-info-popover container="body" info="When enabled, the sync will intentionally fail for testing error handling."></app-info-popover>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer border-top-0 pt-0 api-platform-modal-actions">
    <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="savePlatformAuth()">Save configuration</button>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #authCadmiumModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authCadmiumForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">

        <div class="row mx-auto">
<!--          <div class="col-lg-12 col-md-12 col-ms-12">-->
<!--            <div class="floating-label">-->
<!--              <input formControlName="api_url" placeholder=" "-->
<!--                     required="required" class="floating-input"-->
<!--                     type="text" autocomplete="off"/>-->
<!--              <label>API URL <span class="red">*</span>-->
<!--              </label>-->
<!--              <div *ngIf="submitted && c.api_url.errors" class="bar error-brd">-->
<!--                <div *ngIf="c.api_url.errors !== null && !c.api_url.errors.required" class="invalid-text">Please enter-->
<!--                  valid API URL format-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

          <div class="col-lg-6 col-md-6 col-ms-6">
            <div class="api-platform-field">
              <label class="api-platform-field-label">API Key <span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('api_key')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="api_key"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new API Key"/>
              <div *ngIf="submitted && c.api_key.errors" class="mt-1">
                <div *ngIf="c.api_key.errors !== null && c.api_key.errors.required" class="invalid-text">API KEY is required</div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-ms-6">
            <div class="api-platform-field">
              <div class="d-flex align-items-center flex-wrap mb-1">
                <label class="api-platform-field-label mb-0">Filter By (optional)</label>
                <app-info-popover class="flex-shrink-0 ml-1" container="body"
                  info="Optional. Leave blank to import all allowed records. To limit what syncs, enter one JSON object: a Cadmium field name and the value it must match.&#10;&#10;Examples:&#10;{ &quot;PresenterPosition&quot;: &quot;CEO&quot; }&#10;{ &quot;status&quot;: &quot;active&quot; }"></app-info-popover>
              </div>
              <input formControlName="filter_by" placeholder='e.g. { "PresenterPosition": "CEO" }'
                     class="api-platform-input form-control"
                     type="text" autocomplete="off"/>
              <div class="mt-1">
                <div *ngIf="!isCadmiumFormValid" class="invalid-text">Please fill all values</div>
              </div>
            </div>
          </div>

<!--          <div class="col-lg-4 col-md-12 col-ms-12 mt-3">-->
<!--             <app-creatable-select #attendeeSegment placeholder="Select segment" [selectOptions]="attendeeSegments"-->
<!--                                   [hideInfo]="true" [placeholder]="'Select Attendee Segment'"-->
<!--                                   [labelText]="'Select Attendee Segment'"-->
<!--                                   (optionSelected)="onSegmentSelect($event, 'attendee')"-->
<!--                                   [selectedValue]="selectedAttendeeSegment"></app-creatable-select>-->
<!--          </div>-->
          <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #speakerSegment placeholder="Select segment" [selectOptions]="speakerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Select Speaker Segment'"
                                  (optionSelected)="onSegmentSelect($event, 'speaker')"
                                  [selectedValue]="selectedSpeakerSegment"></app-creatable-select>
          </div>
<!--          <div class="col-lg-4 col-md-12 col-ms-12 mt-3">-->
<!--            <app-creatable-select #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"-->
<!--                                  [hideInfo]="true" [placeholder]="'Select Partner Segment'"-->
<!--                                  [labelText]="'Select Partner Segment'"-->
<!--                                  (optionSelected)="onSegmentSelect($event, 'partner')"-->
<!--                                  [selectedValue]="selectedPartnerSegment"></app-creatable-select>-->
<!--          </div>-->
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Skip records if…</p>
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Missing email
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable share links
              </label>
            </div>
          </div>
          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">On deletion</p>
            <div class="api-platform-option-list">
              <div class="d-flex align-items-center url-type flex-wrap">
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>


<ng-template #authSessionBoardModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authSessionBoardForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">

          <div class="row mx-auto">
              <div class="col-lg-6 col-md-12 col-ms-12">
                <div class="api-platform-field">
                  <label class="api-platform-field-label">Event ID</label>
                  <input formControlName="event_id"
                         class="api-platform-input form-control"
                         type="text" autocomplete="off" placeholder="Enter Event ID"/>
                  <div class="mt-1">
                    <div *ngIf="!isSessionBoardFormValid" class="invalid-text">Please fill all values</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-12 col-ms-12">
                <div class="api-platform-field">
                  <label class="api-platform-field-label">Access Token</label>
                  <small *ngIf="isCredentialFieldConfigured('access_token')" class="text-success d-block">
                    Configured — leave blank to keep the current value
                  </small>
                  <input formControlName="access_token"
                         class="api-platform-input form-control"
                         type="password" autocomplete="new-password"
                         placeholder="Enter a new Access Token"/>
                  <div class="mt-1">
                    <div *ngIf="!isSessionBoardFormValid" class="invalid-text">Please fill all values</div>
                  </div>
                </div>
              </div>

           <!-- <div class="col-lg-4 col-md-12 col-ms-12 mt-3">
              <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #attendeeSegment placeholder="Select segment" [selectOptions]="attendeeSegments"
                                    [hideInfo]="true" [placeholder]="'Select Attendee Segment'"
                                    [labelText]="'Select Attendee Segment'"
                                    (optionSelected)="onSegmentSelect($event, 'attendee')"
                                    [selectedValue]="selectedAttendeeSegment"></app-creatable-select>
            </div>-->
            <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
              <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #speakerSegment placeholder="Select segment" [selectOptions]="speakerSegments"
                                    [hideInfo]="true" [placeholder]="'Select segment'"
                                    [labelText]="'Select Speaker Segment'"
                                    (optionSelected)="onSegmentSelect($event, 'speaker')"
                                    [selectedValue]="selectedSpeakerSegment"></app-creatable-select>
            </div>
            <div class="col-lg-6 col-md-12 col-ms-12 mt-2">
              <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"
                                    [hideInfo]="true" [placeholder]="'Select segment'"
                                    [labelText]="'Select Partner Segment'"
                                    (optionSelected)="onSegmentSelect($event, 'partner')"
                                    [selectedValue]="selectedPartnerSegment"></app-creatable-select>
            </div>
            <div class="col-12 api-platform-section">
              <p class="api-platform-section-title">Skip records if…</p>
              <div class="api-platform-option-list">
                <label class="custom-checkbox d-block mb-0">
                  <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                  <span class="checkmark"></span>
                  Missing email
                </label>
              </div>
            </div>
            <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
              <div class="api-platform-option-list">
                <label class="custom-checkbox d-block mb-0">
                  <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                  <span class="checkmark"></span>
                  Enable share links
                </label>
              </div>
            </div>
            <div class="col-12 api-platform-section">
              <p class="api-platform-section-title">On deletion</p>
              <div class="api-platform-option-list">
                <div class="d-flex align-items-center url-type flex-wrap">
                  <label class="custom-radio">
                    <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                  </label>
                  <ng-container>
                    <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                  </ng-container>
                  <label class="custom-radio">
                    <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                  </label>
                  <ng-container>
                    <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                  </ng-container>
                  <label class="custom-radio">
                    <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                  </label>
                  <ng-container>
                    <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                  </ng-container>
                  <label class="custom-radio">
                    <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                  </label>
                  <ng-container>
                    <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #logsTable let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1" id="modal-title">Sync logs</h4>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="modal.dismiss('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isImportDataFilled()" class="import-data-container mt-4">
      <div class="custom-table">
        <table class="sb-table table dataTable no-footer nowrap" datatable [dtOptions]="importDataTableOptions"
               id="dt1-table">
          <thead>
          <tr>
            <th *ngFor="let fieldName of importDataTableColumns()">{{fieldName}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of importData['list']">
            <td  class="delete-log" *ngFor="let field of importDataTableColumns()">{{data[field]}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <input type="hidden" ngbAutofocus>
  <div class="modal-footer border-top-0 pt-2 api-platform-modal-actions">
    <button type="button" class="btn btn-outline-platform" (click)="modal.close()">Close</button>
  </div>
</ng-template>


<ng-template #apiIntegrationGuideModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">Integration guide — {{platformName}}</h4>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancelApiIntegrationModel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="apiIntegrationGuide" [innerHTML]="apiIntegrationGuide | sanitizeHtml: 'html'">
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #authMapYourShowModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authMapYourShowForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">
        <div class="row mx-auto">
          <div class="col-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Event show code <span class="text-danger">*</span></label>
              <input formControlName="show_code" class="api-platform-input form-control"
                     type="text" autocomplete="off" placeholder="Enter show code"/>
              <div *ngIf="submitted && m.show_code.errors" class="mt-1">
                <div *ngIf="m.show_code.errors.required" class="invalid-text">Show code is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Exhibitor segment'"
                                  (optionSelected)="onMYSSegmentSelect($event, 'exhibitor')"
                                  [selectedValue]="selectedMYSExhibitorSegment"></app-creatable-select>
          </div>
          <div class="col-lg-6 col-md-6 col-12 mt-2">
            <app-creatable-select ngSelectAppendTo=".api-platform-auth-modal" #speakerSegment placeholder="Select segment" [selectOptions]="speakerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Speaker segment'"
                                  (optionSelected)="onMYSSegmentSelect($event, 'speaker')"
                                  [selectedValue]="selectedMYSSpeakerSegment"></app-creatable-select>
          </div>

          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Skip records if…</p>
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-2">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Missing email
              </label>
              <label class="custom-checkbox d-block mb-2">
                <input class="mr-1" formControlName="skip_records_with_faulty_image" type="checkbox" value="true">
                <span class="checkmark"></span>
                Broken image
              </label>
              <label class="custom-checkbox d-block mb-2">
                <input class="mr-1" formControlName="filter_by_status_approved" type="checkbox" value="true">
                <span class="checkmark"></span>
                Already approved
              </label>
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_duplicate_contacts" type="checkbox" value="true">
                <span class="checkmark"></span>
                Skip duplicate contacts
              </label>
            </div>
          </div>

          <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable share links
              </label>
            </div>
            <div class="api-platform-option-list d-flex flex-wrap align-items-center">
              <label class="custom-checkbox mb-0 mr-2">
                <input class="mr-1" formControlName="handle_already_skipped" type="checkbox" value="unskip">
                <span class="checkmark"></span>
                Unskip previously skipped records
              </label>
              <app-info-popover container="body" info="Automatically clear skip field for all influencers updated via sync."></app-info-popover>
            </div>
          </div>

          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">On deletion</p>
            <div class="api-platform-option-list">
              <div class="d-flex align-items-center url-type flex-wrap">
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>

<ng-template #authPersonifyA2ZModel let-modal>
  <div class="modal-header api-platform-modal-header">
    <div class="flex-grow-1 pr-3">
      <h4 class="modal-title mb-1">{{platformName}}</h4>
      <a *ngIf="apiIntegrationGuide" class="api-platform-modal-guide" [href]="shareSyncLinkUrl" target="_blank">View how-to guide</a>
    </div>
    <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="isSegmentSelect" class="custom-error invalid-text mt-0">{{isSegmentSelect}}</div>
    <div class="form-wraper">
      <form [formGroup]="authPersonifyA2ZForm" (ngSubmit)="savePlatformAuth()" autocomplete="off">
        <div class="row mx-auto">
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Event ID <span class="text-danger">*</span></label>
              <input formControlName="event_id"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off" placeholder="Enter Event ID"/>
              <div *ngIf="submitted && p.event_id.errors" class="mt-1">
                <div *ngIf="p.event_id.errors.required" class="invalid-text">Event Id is required</div>
                <div *ngIf="p.event_id.errors.pattern" class="invalid-text">Event Id must be an integer</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Tenant ID <span class="text-danger">*</span></label>
              <small *ngIf="isCredentialFieldConfigured('tenant_id')" class="text-success d-block">
                Configured — leave blank to keep the current value
              </small>
              <input formControlName="tenant_id"
                     class="api-platform-input form-control"
                     type="password" autocomplete="new-password" placeholder="Enter a new Tenant ID"/>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Promo code field name</label>
              <input formControlName="promo_code_field_name"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off"
                     placeholder="Leave empty to skip"/>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Registration link field name</label>
              <input formControlName="reg_link_field_name"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off"
                     placeholder="Leave empty to skip"/>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12">
            <div class="api-platform-field">
              <label class="api-platform-field-label">Custom contact field name</label>
              <input formControlName="custom_contact_field_name"
                     class="api-platform-input form-control"
                     type="text" autocomplete="off"
                     placeholder="Leave empty to skip"/>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-ms-12 mt-2 mt-lg-0">
            <app-creatable-select containerClass="personify-a2z-segment-creatable" ngSelectAppendTo=".api-platform-auth-modal" #partnerSegment placeholder="Select segment" [selectOptions]="partnerSegments"
                                  [hideInfo]="true" [placeholder]="'Select segment'"
                                  [labelText]="'Exhibitor segment'"
                                  (optionSelected)="onSegmentSelect($event, 'partner')"
                                  [selectedValue]="selectedPartnerSegment"></app-creatable-select>
          </div>

          <div class="col-12 api-platform-section" *ngIf="currentPlatform?.supports_push_links">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="enable_push_links" type="checkbox" value="true">
                <span class="checkmark"></span>
                Enable share links
              </label>
            </div>
          </div>

          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">Skip records if…</p>
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_records_without_email" type="checkbox" value="true">
                <span class="checkmark"></span>
                Missing email
              </label>
            </div>

            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-0">
                <input class="mr-1" formControlName="skip_duplicate_contacts" type="checkbox" value="true">
                <span class="checkmark"></span>
                Skip duplicate contacts
              </label>
            </div>
          </div>

          <div class="col-12 api-platform-section">
            <div class="api-platform-option-list">
              <label class="custom-checkbox d-block mb-2">
                <input class="mr-1" formControlName="include_booth_contact" type="checkbox" value="true">
                <span class="checkmark"></span>
                Include booth contact
              </label>
              <div class="d-flex flex-wrap align-items-center">
                <label class="custom-checkbox mb-0 mr-2">
                  <input class="mr-1" formControlName="handle_already_skipped" type="checkbox" value="unskip">
                  <span class="checkmark"></span>
                  Unskip previously skipped records
                </label>
                <app-info-popover container="body" info="Automatically clear skip field for all add/update influencers as the result of import."></app-info-popover>
              </div>
            </div>
          </div>
<!--          <div class="col-lg-12 col-md-12 col-ms-12 mt-4">-->
<!--            <label> Skip duplicate contacts</label>-->
<!--            <div class="ml-2">-->
<!--              <label class="custom-checkbox">-->
<!--                <input class="mr-1" formControlName="skip_duplicate_contacts" type="checkbox" value="true">-->
<!--                <span class="checkmark"></span>-->
<!--                Skip-->
<!--              </label>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-lg-12 col-md-12 col-ms-12 mt-3">-->
<!--            <label>How to handle deletion</label>-->
<!--            <div class="d-flex align-items-center url-type">-->
<!--              <label class="custom-radio">-->
<!--                <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball-->
<!--              </label>-->
<!--              <ng-container>-->
<!--                <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is." ></app-info-popover>-->
<!--              </ng-container>-->

<!--              <label class="custom-radio">-->
<!--                <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball-->
<!--              </label>-->
<!--              <ng-container>-->
<!--                <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead." ></app-info-popover>-->
<!--              </ng-container>-->

<!--              <label class="custom-radio">-->
<!--                <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Delete on Snöball Forced-->
<!--              </label>-->
<!--              <ng-container>-->
<!--                <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals." ></app-info-popover>-->
<!--              </ng-container>-->

<!--              <label class="custom-radio">-->
<!--                <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball" checked="checked"><span class="radiomark"></span>Skip on Snöball-->
<!--              </label>-->
<!--              <ng-container>-->
<!--                <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails." ></app-info-popover>-->
<!--              </ng-container>-->

          <div class="col-12 api-platform-section">
            <p class="api-platform-section-title">On deletion</p>
            <div class="api-platform-option-list">
              <div class="d-flex align-items-center url-type flex-wrap">
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="keep_on_snoball"><span class="radiomark"></span>Keep on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Does not affect deleted influencers. It remains as it is."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball"><span class="radiomark"></span>Delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, if influencer has referrals it will be opt-ed out instead."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="delete_on_snoball_forced"><span class="radiomark"></span>Force delete on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Clears all influencer data including stats, even if it has referrals."></app-info-popover>
                </ng-container>
                <label class="custom-radio">
                  <input class="mx-2" type="radio" formControlName="handle_deletion" value="skip_on_snoball"><span class="radiomark"></span>Skip on Snöball
                </label>
                <ng-container>
                  <app-info-popover container="body" info="Excludes influencer from being added to campaigns and receiving campaign emails."></app-info-popover>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-4 pt-2 api-platform-modal-actions">
          <button type="button" class="btn mr-2 btn-outline-platform" (click)="onCancel()">Cancel</button>
          <button type="submit" class="btn btn-primary">Activate</button>
        </div>
      </form>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
</ng-template>
